import React from "react";
import { getShimmerClass } from "utils/constants/ui";
import classnames from "classnames";

const FeatureComparisonLoader = ({ withShimmer }) => {
  const shimmerClass = getShimmerClass(withShimmer);

  return (
    <div className="w-100">
      <table className="w-100 center mt5" cellSpacing="0">
        <thead>
          <tr>
            {new Array(4).fill("").map((_, itemIx) => (
              <th
                key={itemIx}
                className={classnames("fw6 bb b--black-10 tl pb3 pr3", {
                  w5: !itemIx
                })}
              >
                <div
                  className={classnames(shimmerClass, {
                    "w-100 h3": !itemIx,
                    "w-50 h2 center": itemIx
                  })}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="lh-copy">
          {new Array(4).fill("").map((_, itemIx) => (
            <tr key={itemIx}>
              <td className="pv3 pr3 bb b--black-10">
                <div
                  className={classnames(`h2 ${shimmerClass}`, {
                    "w-70": itemIx === 0,
                    "w-80": itemIx === 1,
                    "w-60": itemIx === 2
                  })}
                ></div>
              </td>
              <td className="pv3 pr3 bb b--black-10">
                <div className={`w2 h2 center ${shimmerClass}`}></div>
              </td>
              <td className="pv3 pr3 bb b--black-10">
                <div className={`w2 h2 center ${shimmerClass}`}></div>
              </td>
              <td className="pv3 pr3 bb b--black-10">
                <div className={`w2 h2 center ${shimmerClass}`}></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FeatureComparisonLoader;
